// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"PageNotFound_pageNotFound__12D-g","button":"PageNotFound_button__1H8hO"};